import { Icon } from '@chakra-ui/icons';
import { useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const XIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 48 48" {...rest} __css={styles}>
      <desc id="svgdescX">X Logo</desc>
      <rect className="accent" x="0" y="0" width="48" height="48" rx="64" />
      <path
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
        d="M0,0v48h48V0H0z M30,38.5l-7.7-10.1l-8.9,10.1H8.6l11.5-13.1L8,9.5h10.1l7,9.2l8.2-9.2h4.8L27.4,21.9l12.7,16.7
        H30L30,38.5z M16.6,12.3l17.6,23.4h-2.7L13.7,12.3h3H16.6z"
      />
    </Icon>
  );
};

export default XIcon;
